/*
 * Based on the ProblemsPanel component from the basedpyright-playground
 */

import { renderIconDefinitionToSVGElement } from '@ant-design/icons-svg/es/helpers';
import { IconDefinition } from '@ant-design/icons-svg/lib/types';
import { Box } from '@mui/material';

export interface SvgIconProps {
  iconDefinition: IconDefinition;
  iconSize: number;
  color: string;
}

export function SvgIcon(props: SvgIconProps) {
  const svgElement = renderIconDefinitionToSVGElement(props.iconDefinition, {
    extraSVGAttrs: {
      width: `${props.iconSize}px`,
      height: `${props.iconSize}px`,
      fill: props.color,
    },
  });

  return (
    <Box sx={styles.container}>
      <div
        style={{
          display: 'flex',
          height: props.iconSize,
          width: props.iconSize,
          ...styles.iconContainer,
        }}
        dangerouslySetInnerHTML={{ __html: svgElement }}
      />
    </Box>
  );
}

const styles = {
  defaultBackgroundStyle: {
    paddingHorizontal: 6,
    paddingVertical: 2,
  },
  container: {
    flex: -1,
    justifyContent: 'center',
  },
  iconContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  disabled: {
    opacity: 1,
    cursor: 'default',
  },
};
